import React from "react";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import TextError from "../../../Components/HealthInsFormikComponent/TextError";
import DobCKYC from "../../CareHealthKYC/CKYC/DobCKYC";
function StarAdhrPrfPos(props) {
  const { formik } = props;
  // const initialValues = {
  //   gender: "",
  //   dob : "",
  //   applicantName : '',
  //   adhaarNum : ''
  // };
  // const onSubmit = (data) => {
  //   console.log("AdhrPrfPos: ",data);
  //   let docNumber = data.adhaarNum + data.applicantName + data.dob + data.gender
  //   console.log ("AdhrPrfPosNumb: ",docNumber);
  //   formik.setValue("docNumber", docNumber);
  // };

  return (
    <div>
      {/* {
        <Formik
          enableReinitialize
          initialValues={initialValues}
          //   validationSchema={validationSchema}
            onSubmit={onSubmit}
            
        >
          {(formik) => ( */}
      <div>
        <div className="d-flex flex-nowrap justify-content-center bd-highlight mb-4">
          <div className="maleRadioGroup">
            <div className="radioGroupBelow">
              <label htmlFor="maleGender">
                <Field type="radio" name="gender" value="M" id="maleGender" />
                <span>Male</span>
              </label>
            </div>
          </div>

          <div className="femaleRadioGroup">
            <div className="radioGroupBelow">
              <label htmlFor="maleGender">
                <Field
                  type="radio"
                  name="gender"
                  value="F"
                  id="maleGender"
                  className={formik.touched.name ? "successField" : null}
                />
                Female
              </label>
            </div>
          </div>
          <div className="transGenderRadioGroup">
            <div className="radioGroupBelow">
              <label htmlFor="maleGender">
                <Field
                  type="radio"
                  name="gender"
                  value="T"
                  id="maleGender"
                  className={formik.touched.name ? "successField" : null}
                />
                Other
              </label>
            </div>
          </div>
        </div>
        <div className="d-flex flex-nowrap justify-content-center bd-highlight mb-4">
          <ErrorMessage name="gender" component={TextError} />
        </div>

        <div className="form-group  " style={{ paddingTop: "20px" }}>
          <label
            htmlFor="adhaarNum"
            className="fw-light"
            style={{ paddingBottom: "8px" }}
          >
            Aadhaar – Last 4 digits of Aadhaar Number
          </label>
          <div className="input-icons">
            <Field
              type="text"
              name="adhaarNum"
              id="adhaarNum"
              className={
                formik.touched.adhaarNum && formik.errors.adhaarNum
                  ? " errorStyle form-control bg-white"
                  : !formik.errors.adhaarNum && formik.touched.adhaarNum
                  ? " successField form-control bg-white"
                  : " form-control bg-white"
              }
            />
          </div>
          <ErrorMessage name="adhaarNum" component={TextError} />
        </div>
        <div className="form-group  " style={{ paddingTop: "20px" }}>
          <label
            htmlFor="applicantName"
            className="fw-light"
            style={{ paddingBottom: "8px" }}
          >
            Applicant Name – As it appears in the Aadhaar
          </label>
          <div className="input-icons">
            <Field
              type="text"
              name="applicantName"
              id="applicantName"
              className={
                formik.touched.applicantName && formik.errors.applicantName
                  ? " errorStyle form-control bg-white"
                  : !formik.errors.applicantName && formik.touched.applicantName
                  ? " successField form-control bg-white"
                  : " form-control bg-white"
              }
            />
          </div>

          <ErrorMessage name="applicantName" component={TextError} />
        </div>

        <div className="form-group mb-3 " style={{ paddingTop: "20px" }}>
          <label
            htmlFor="star_adhaar_dob"
            className="fw-light"
            style={{ paddingBottom: "8px" }}
          >
            Date of Birth
          </label>
          <div className="input-icons">
            <Field
              type="text"
              name="star_adhaar_dob"
              id="star_adhaar_dob"
              className={
                formik.touched.star_adhaar_dob && formik.errors.star_adhaar_dob
                  ? " errorStyle form-control bg-white"
                  : !formik.errors.star_adhaar_dob && formik.touched.star_adhaar_dob
                  ? " successField form-control bg-white"
                  : " form-control bg-white"
              }
              component={DobCKYC}
            />
          </div>
          <ErrorMessage name="star_adhaar_dob" component={TextError} />
        </div>
      </div>
      {/* )}
        </Formik>
      }  */}
    </div>
  );
}

export default StarAdhrPrfPos;
